import { Flex } from 'components/flex';
import { List } from 'components/list';
import { Drawer } from 'components/drawer';
import { Avatar } from 'components/avatar';
import { formatPrice } from 'utils/helpers';
import { ListCard } from 'components/list-card';
import { EventCheckout } from 'store/api/event';
import { InfoBlock } from 'components/info-block';
import { ListHeader } from 'components/list-header';
import { formatTimezoneSpecific } from 'utils/date';

import * as Styles from './styles';
import { ProductsProps, ExchangeDetailsProps } from './types';
import { calculateDifferenceExchangeAndCheckoutItems } from './helpers';

const titles = ['Product', 'Price', 'Quantity'];
const cellsMobile = [
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '1/2' },
  { row: '2/3', col: '2/3' },
];
const commonColProps = {
  col: 3,
  colTablet: 6,
  colMobile: 6,
};

const getCheckoutItems = (data?: EventCheckout, isExchange?: boolean) =>
  data?.items?.filter((item) => !!item.isExchange === !!isExchange) || [];

const Products = ({ title, values }: ProductsProps) => (
  <Flex column>
    <h3>{title}</h3>
    <List
      count={values?.length}
      mainWrapperStyles={{ padding: 0 }}
      header={<ListHeader titles={titles} />}
    >
      {values?.map((value) => (
        <ListCard
          key={value.id}
          headers={titles}
          cellsMobile={cellsMobile}
          values={[
            <Flex gap={8} alignItems="center">
              <Avatar url={value?.product?.image} />
              <h4>{value?.product?.name}</h4>
            </Flex>,
            formatPrice(value?.price),
            value?.quantity,
          ]}
        />
      ))}
    </List>
  </Flex>
);

export const ExchangeDetails = ({
  data,
  opened,
  onClose,
}: ExchangeDetailsProps) => {
  if (!data) {
    return null;
  }

  return (
    <Drawer opened={opened} topOffset="20%" onClose={onClose}>
      <Styles.StyledDetails
        withoutPhoto
        disableSticky
        name="Exchange"
        withPlaceholders
        stickyWithHeader={false}
        sectionWrapper={InfoBlock}
        containerStyles={{ gap: '16px' }}
        sections={[
          {
            rows: [
              [
                {
                  ...commonColProps,
                  title: 'Date',
                  value: formatTimezoneSpecific(
                    data.createdAt,
                    data?.event?.timezone?.code
                  ),
                },
                {
                  ...commonColProps,
                  title: 'Event',
                  value: data?.event?.name,
                },
                {
                  ...commonColProps,
                  title: 'Sale Total',
                  value: formatPrice(data?.saleTotal),
                },
                {
                  ...commonColProps,
                  title: 'Return Amount',
                  value: formatPrice(data.exchangeItemsAmount),
                },
              ],
              [
                {
                  ...commonColProps,
                  title: 'Exchange Amount',
                  value: formatPrice(
                    calculateDifferenceExchangeAndCheckoutItems(data)
                  ),
                },
              ],
            ],
          },
        ]}
      />

      <Flex column gap={24}>
        <Products
          title="Return Products"
          values={getCheckoutItems(data, true)}
        />

        <Products
          title="Replacement Products"
          values={getCheckoutItems(data)}
        />
      </Flex>
    </Drawer>
  );
};
